import Joi from 'joi';
import PropTypes from 'prop-types';

import Button from '../../themed/button';
import Form from '../../common/form';

import { EXCEL_APPLICATION_TYPE, IMAGE_LIMITS } from '../../../utils/constants';
import { PDFImageProps } from '../../../utils/models';

import toastService from '../../../services/toastService';

class ExcelISODocument extends Form {
	state = {
		data: { excelIsoUpload: [] },
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		excelIsoUpload: Joi.array().min(1).max(IMAGE_LIMITS.EXCEL_ISO_UPLOAD).required().label('Anomaly location or ISO or Drawing'),
	};

	static propTypes = {
		onAdd: PropTypes.func,
		onCancel: PropTypes.func,
	};

	doSubmit = (): void => {
		const excelFile: PDFImageProps = this.state.data.excelIsoUpload[0];
		this.props.onAdd(excelFile.src);

		toastService.success('Anomaly location or ISO or Drawing uploaded successfully');
	};

	render() {
		return (
			<div className="p-3 bg-light border curved-edges">
				<form autoComplete="off" onSubmit={this.handleSubmit}>
					{this.renderFileInput({
						max: IMAGE_LIMITS.EXCEL_ISO_UPLOAD,
						multiple: IMAGE_LIMITS.EXCEL_ISO_UPLOAD > 1,
						name: 'excelIsoUpload',
						accept: EXCEL_APPLICATION_TYPE,
						label: 'Anomaly location or ISO or Drawing (Excel File)',
						sublabel: 'Upload Anomaly location or ISO or Drawing',
						types: [EXCEL_APPLICATION_TYPE],
					})}

					<div className="d-flex justify-content-end">
						{this.renderButton('Save Document')}

						<div className="mx-4">
							<Button
								label="Cancel"
								style={{ backgroundColor: 'red' }}
								onClick={this.props.onCancel}
							/>
					</div>
				</div>
				</form>
			</div>
		);
	}
}

export default ExcelISODocument;
